import { Button, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useTrackInvoiceView } from '../../../../hooks/useTrackInvoiceView'

export const RegisterPaymentButton = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoiceView } = useTrackInvoiceView()
  const { open } = useModal(ModalId.InvoiceReconciliationModal)
  const handleRegisterPaymentClick = useCallback(() => {
    trackInvoiceView('Register payment clicked')
    open()
  }, [open, trackInvoiceView])

  return (
    <Button icon="handCoins" loading={false} onClick={handleRegisterPaymentClick} variant="filled">
      {t('external_invoices.view.register_payment')}
    </Button>
  )
}
